<template>
  <IngredientsBaseSection
    title="Ingredients with Daily Values"
    :items="store.dvLines"
    section-key="dv-lines"
    :is-dv-line="true"
    :just-added-index="store.justAddedDvLineIndex"
    list-class="dv-lines-list"
    focus-selector=".nutrient-combobox input"
    empty-message="No ingredients added yet. Click below to add vitamins, minerals, or other nutrients with established Daily Values."
    clear-type="dvLines"
    @add="store.addDvLine"
    @clear-added-index="store.clearJustAddedDvLineIndex"
    @invalid-dv-input="handleInvalidDvInput"
  >
    <template #title>
      <span
        >Ingredients with <span class="is-hidden-desktop-until-widescreen">Daily Values</span
        ><span class="is-hidden-widescreen">DVs</span></span
      >
    </template>
    <template #extra-content-top>
      <WarningsBox :compliance="store.dvWarnings" />
    </template>
    <template #extra-content-bottom>
      <div class="dv-mobile-add-wrapper is-hidden-desktop" data-sticky-footer>
        <div class="dv-mobile-add-container">
          <button type="button" class="button is-success is-fullwidth" @click="handleMobileAdd">
            <span class="icon"><i class="fas fa-plus"></i></span>
            <span>Add {{ hasLines ? "Another " : "" }}Ingredient</span>
          </button>
        </div>
      </div>
    </template>
  </IngredientsBaseSection>

  <IngredientsInvalidDvDialog
    v-model="showInvalidDialog"
    :ingredient-name="invalidIngredientName"
    @close="handleInvalidDialogClose"
  />
</template>

<script setup>
  import { computed, ref, inject } from "vue";
  import { useSupplementLabelStore } from "../stores/supplement-label-store";
  import IngredientsBaseSection from "./ingredients-base-section.vue";
  import IngredientsInvalidDvDialog from "./ingredients-invalid-dv-dialog.vue";
  import WarningsBox from "./warnings-box.vue";
  import { focusAfterAdd } from "./utils/focus-helpers";

  const store = useSupplementLabelStore();
  const triggerSave = inject("triggerSave");

  const hasLines = computed(() => store.dvLines.length > 0);

  // Invalid DV input handling
  const showInvalidDialog = ref(false);
  const invalidIngredientName = ref("");
  const invalidLineUid = ref(null);

  function handleInvalidDvInput({ uid, invalidText }) {
    invalidIngredientName.value = invalidText;
    invalidLineUid.value = uid;
    showInvalidDialog.value = true;
  }

  function handleInvalidDialogClose() {
    // Remove the invalid line
    if (invalidLineUid.value !== null) {
      const index = store.dvLines.findIndex((l) => l._uid === invalidLineUid.value);
      if (index !== -1) {
        store.removeDvLine(index);
        triggerSave?.();
      }
    }
    invalidLineUid.value = null;
    invalidIngredientName.value = "";
  }

  function handleMobileAdd() {
    store.addDvLine();
    focusAfterAdd(".dv-lines-list .nutrient-combobox input", () =>
      store.clearJustAddedDvLineIndex()
    );
  }
</script>

<style lang="scss" scoped>
  @import "~/label/css/labels/supplements/supplement_mixins";

  .dv-mobile-add-wrapper {
    @include sticky-mobile-footer(5);
  }

  .dv-mobile-add-container {
    padding-top: 0.5rem;
    padding-bottom: 0;
    background: $white;
  }
</style>
